import { createIcon } from '@chakra-ui/icons';

export const TwitterIcon = createIcon({
  displayName: 'TwitterIcon',
  viewBox: '0 0 32 32',
  path: [
    <g key="1" clipPath="url(#shareTwitter)">
      <path
        d="M16.0008 31.9997C24.8373 31.9997 32.0007 24.8363 32.0007 15.9999C32.0007 7.16338 24.8373 0 16.0008 0C7.16436 0 0.000976562 7.16338 0.000976562 15.9999C0.000976562 24.8363 7.16436 31.9997 16.0008 31.9997Z"
        fill="#55ACEE"
      />
      <path
        d="M25.8011 11.4985C25.1154 11.8025 24.3779 12.0082 23.6044 12.1C24.3941 11.6268 25.0002 10.8782 25.2863 9.98459C24.5473 10.423 23.7284 10.741 22.8577 10.9124C22.1601 10.1694 21.1661 9.70508 20.0655 9.70508C17.9537 9.70508 16.241 11.4178 16.241 13.5295C16.241 13.8293 16.275 14.121 16.3406 14.4011C13.1622 14.2417 10.344 12.7192 8.45759 10.4047C8.12845 10.9694 7.93964 11.6268 7.93964 12.3276C7.93964 13.6541 8.61531 14.8252 9.64093 15.5109C9.01432 15.4912 8.42422 15.3192 7.90884 15.032C7.90855 15.0483 7.90855 15.0645 7.90855 15.0805C7.90855 16.9335 9.22738 18.4791 10.9766 18.8302C10.656 18.918 10.3175 18.9645 9.96921 18.9645C9.72222 18.9645 9.48293 18.9408 9.24962 18.8963C9.7362 20.4154 11.1483 21.5212 12.8222 21.5522C11.5131 22.5782 9.86426 23.1894 8.07198 23.1894C7.76395 23.1894 7.45877 23.1714 7.16016 23.1357C8.85175 24.2213 10.8625 24.8541 13.0221 24.8541C20.0566 24.8541 23.9036 19.0267 23.9036 13.9724C23.9036 13.8067 23.8999 13.6416 23.8924 13.4779C24.6403 12.9388 25.2886 12.2654 25.8011 11.4985Z"
        fill="#F1F2F2"
      />
    </g>,
    <defs key="2">
      <clipPath id="shareTwitter">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>,
  ],
});
